import { styled } from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

interface BackgroundWrapperProps {
  backgroundImage?: string;
}

export const BackgroundWrapper = styled.div<BackgroundWrapperProps>`
  width: 100%;
  height: 100%;
  background: ${(props) =>
    props.backgroundImage
      ? `url('${props.backgroundImage}') center/cover no-repeat`
      : '#14111e'};
  position: relative;
  display: flex;
  flex-direction: column;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      180deg,
      rgba(30, 15, 52, 0) 34.01%,
      rgba(30, 15, 52, 0.73) 61.86%,
      #1e0f34 89.85%
    );
    z-index: 1;
    pointer-events: none;
  }
`;

export const PageStyles = styled(OnboardingPage)`
  ion-content {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    position: relative;
    padding-bottom: 100px;
    z-index: 2;
    background: transparent;

    &::before {
      display: none;
    }
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  max-width: 468px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-end;
  min-height: 0;
  padding-bottom: 24px;
  height: 100%;
  flex: 1 1 auto;
  box-sizing: border-box;
`;

export const Main = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  z-index: 2;
  flex: 1 1 auto;
  justify-content: flex-end;
  min-height: 0;
  padding-left: 16px;
`;

export const Badges = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 18px;
`;

export const Badge = styled.span<{ variant?: 'private' | 'fire' }>`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-align: center;
  border-radius: 16px;
  padding: 8px 16px;
  background: ${({ variant }) =>
    variant === 'private'
      ? 'var(--badges-color-videos)'
      : variant === 'fire'
        ? 'var(--badges-color-roleplay)'
        : '#222'};
  color: #fff;
  gap: 8px;
`;

export const Title = styled.div`
  color: var(--text-color-white);
  font-weight: 500;
  font-size: 28px;
  line-height: 34px;
  letter-spacing: 0.36px;
  margin-bottom: 8px;
`;

export const Subtitle = styled.div`
  color: var(--text-color-neutral-white);
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.41px;
  margin-bottom: 20px;
`;

export const Tag = styled.span`
  display: flex;
  align-items: center;
  background: rgba(20, 17, 30, 0.85);
  color: #fff;
  font-size: 16px;
  border-radius: 16px;
  padding: 6px 16px;
  gap: 8px;
`;
